module.exports = __webpack_public_path__ + "static/media/vm.b2ed2b2b.png";